export const blockIconsAndroidNightlightNew = (
	<span className='material-symbols-outlined'>nightlight</span>
);
